module.exports = __webpack_public_path__ + "img/lookbook_15_center.e121f1b7.png";